import { ShortcodeFn } from 'components/vendor/Contentful/richText/ShortcodeManager'
import MortgageWidget from 'components/vendor/MortgageWidget'

export const bbmEmbedWidget: ShortcodeFn = (name, attrs) => {
	const campaign = attrs['campaign']
	return <MortgageWidget defaultFilters={{ result_count: 4 }} campaign={campaign} />
}
